module.exports = __webpack_public_path__ + "static/media/icon01.0596f00a.svg";